/*
 * @Author: zyq
 * @Date: 2022-10-21 12:01:52
 * @LastEditors: zyq
 * @LastEditTime: 2022-10-25 23:29:38
 * @description:
 */
import request from '@/utils/request'

// 获取组织
export function getOrganization () {
  return request({
    url: '/api/organization/getOrganization',
    method: 'get'
  })
}

// 获取题目
export function getTopic (topicIndex) {
  return request({
    url: `/api/topic/getTopic/${topicIndex}`,
    method: 'get'
  })
}

// 获取答案
export function getAnswers (params) {
  return request({
    url: '/api/topic/getAnswers',
    method: 'get',
    params
  })
}

// 获取支部成绩
export function getGradesByOrganization (data) {
  return request({
    url: `/api/grades/getGradesByOrganization/${data.page}/${data.pageSize}`,
    method: 'get'
  })
}

// 我的成绩
export function getGrades () {
  return request({
    url: '/api/grades/getGrades',
    method: 'get'
  })
}

export function calculatePersonalScores () {
  return request({
    url: '/api/grades/calculatePersonalScores',
    method: 'get'
  })
}

// 获取排行榜
export function getGradesByRanking (data) {
  return request({
    url: `/api/grades/getGradesByRanking/${data.type}/${data.pageIndex}/${data.pageSize}`,
    method: 'get'
  })
}

// 获取答题须知
export function getRequirements () {
  return request({
    url: '/api/answerRequirements/getRequirements',
    method: 'get'
  })
}

// 获取答题次数
export function getGradesLimit (data) {
  return request({
    url: `/api/grades/getGradesLimit/${data.limit}`,
    method: 'get'
  })
}

// 计算成绩
export function calculateGrades (data) {
  return request({
    url: `/api/grades/calculateGrades/${data.limit}`,
    method: 'get'
  })
}

// 保存用户信息
export function saveUser (data) {
  return request({
    url: '/api/user/saveUser',
    method: 'post',
    data
  })
}

// 获取权限
export function getUserinfo (data) {
  return request({
    url: `/wx/getUserinfo/${data.code}`,
    method: 'get'
  })
}

// 获取配置信息
export function getWxSign (data) {
  return request({
    url: '/wx/getWxSign',
    method: 'post',
    data
  })
}

//
// export function calculateGrades (data) {
//   return request({
//     url: 'calculateGrades/userid/3',
//     method: 'get'
//   })
// }
